import { svc_addOne, svc_editOne, svc_deleteOne } from "@/services";
import { showServerResponse } from "@/utils/message";
const apiPrefix = "option_groups/category";

const Model = {
	namespace: "m_CategoryOptionGroup",
	state: {},
	reducers: {},
	effects: {
		*addOptionGroup({ payload }, { call, put }) {
			delete payload.id;
			const response = yield call(svc_addOne, apiPrefix, payload);
			showServerResponse(response);
			return response;
		},
		*updateOptionGroup({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, apiPrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*deleteOptionGroup({ payload }, { call, put }) {
			payload = _.omit(payload, ["key"]);
			const response = yield call(svc_deleteOne, "option_groups/delete/category", payload, "id");
			showServerResponse(response);
			return response;
		},
		*cloneOptionGroup({ payload }, { call, put }) {
			const response = yield call(svc_addOne, apiPrefix, payload, `clone/${payload.id}`);
			showServerResponse(response);
			return response;
		},
		*reorderOptionGroup({ payload }, { call, put }) {
			if (payload && payload.length > 0) {
				const response = yield call(svc_addOne, apiPrefix, payload, "reorder");
				showServerResponse(response);
				return response;
			}
		},
		*updateNextOptionGroup({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_editOne, "option_groups/child/category", payload, "id");
				showServerResponse(response);
				return response;
			}
		},
	},
	subscriptions: {},
};

export default Model;
